import { createMenuBtn } from "@/presentation/prefabs/ui/menuBtn.js";
import { scenesBootstrapper } from "@/presentation/helpers/scenesBootstrapper.js";
import { startSceneLayout } from "@/presentation/layouts/startSceneLayout.js";
import { renderWaterBackground } from "@/presentation/renderers/scenesWaterRenderer.js";
import { createNbPlayerBtn } from "@/presentation/prefabs/ui/nbPlayerBtn.js";
import { createTeamSelectBtn } from "@/presentation/prefabs/ui/teamSelectBtn.js";
import { fadeOut } from "@/presentation/helpers/transitions.js";
import { TEAMS } from "@/game-rules/constants/teams.js";
import { UI_TAGS } from "@/presentation/helpers/uiTags.js";

export function menuScene(k) {
    scenesBootstrapper(k);
    renderWaterBackground(k);
    startSceneLayout(k);

    // ==========================================
    // STEP 3: COLOR SELECTION (VS BOT ONLY)
    // ==========================================
    let preventExtraClick = false;

    const showColorSelection = (nbPlayers) => {
        k.destroyAll(UI_TAGS.NB_PLAYER_BUTTON);

        const availableTeams = TEAMS;

        // Full magic number bb
        const SPACING = 55;
        const SPACINGSECOND = 45;
        const startX = 280;
        const startXSecondLine = 70;

        availableTeams.forEach((team, index) => {
            // Spawn our custom colored sheep button!
            createTeamSelectBtn(k, index < 2 ? startX + (index * SPACING) : startXSecondLine + (index * SPACINGSECOND) ,  index < 2 ? 90 : 150, team, ()=> {
                if (preventExtraClick) return;
                preventExtraClick = true;

                // Transition starts AFTER the sheep finishes its jump!
                fadeOut(k, 2, () => {
                    k.wait(0.4, () => {
                        k.go("game", {
                            mode: "VS_BOT",
                            players: nbPlayers,
                            humanColorId: team.id
                        });
                    });
                });

            });
        });
    };

    // ==========================================
    // STEP 2: PLAYER SELECTION
    // ==========================================
    const showPlayerSelection = (selectedMode) => {
        k.destroyAll(UI_TAGS.MENU_BUTTON);

        const startX = 64 * 9 + 33;
        const playerCounts = [3, 4, 5, 6];

        playerCounts.forEach((nb, index) => {
            createNbPlayerBtn(k, startX + (index * 128), 430, nb, (selectedNb) => {

                if (selectedMode === "HOTSEAT") {
                    // Hotseat goes straight to the game
                    fadeOut(k, 2, () => {
                        k.wait(0.4, () => k.go("game", { mode: "HOTSEAT", players: selectedNb }));
                    });
                } else {
                    // VS Bot goes to Step 3!
                    showColorSelection(selectedNb);
                }
            });
        });
    };

    // ==========================================
    // STEP 1: MODE SELECTION (Runs on start)
    // ==========================================
    // Hotseat Button
    createMenuBtn(k, k.center().x - 415, 290, "HOTSEAT", 22, () => {
        showPlayerSelection("HOTSEAT");
    });

    // VS Bot Button
    createMenuBtn(k, k.center().x - 480, 410, "VS BOT", 24, () => {
        showPlayerSelection("VS_BOT");
    });
}